import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material';
import { FC, useCallback } from 'react';
import DebugInfo, {
  DebugInfoProps,
} from '../../executive-summary/components/DebugInfo';
import { openSnackbar } from '../../snackbar/actions/snackbar-actions';

const ScanDebugInfoModal: FC<
  React.PropsWithChildren<
    DebugInfoProps & { open: boolean; handleClose: () => void }
  >
> = ({
  scanAdditionalInfo,
  scanStartDate,
  scanFinishDate,
  scanId,
  open,
  handleClose,
}) => {
  const copyToClipboard = useCallback(async () => {
    await navigator.clipboard.writeText(
      JSON.stringify({
        scanAdditionalInfo,

        scanId,
      }),
    );
    openSnackbar('Copied!', { variant: 'success' });
  }, [scanAdditionalInfo, scanId]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll='paper'
      fullWidth
      maxWidth='lg'>
      <DialogTitle>Debug Information</DialogTitle>
      <Divider />
      <DialogContent>
        <DebugInfo
          scanStartDate={scanStartDate}
          scanFinishDate={scanFinishDate}
          scanId={scanId}
          scanAdditionalInfo={scanAdditionalInfo}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button autoFocus onClick={copyToClipboard} variant='contained'>
          Copy
        </Button>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScanDebugInfoModal;
